import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const AiIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2L14 7L21 10L14 13L12 18L10 13L3 10L10 7L12 2Z" fill="currentColor"/>
    <path d="M18 13L19 15.5L22 17L19 18.5L18 21L17 18.5L14 17L17 15.5L18 13Z" fill="currentColor"/>
  </SvgIcon>
);